import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import App from './App'
import { UpdatePrompt } from './components/update-prompt'
import './index.css'

const container = document.getElementById('root')
if (!container) throw new Error('Elemento #root nao encontrado em index.html')

createRoot(container).render(
  <StrictMode>
    <App />
    {/* Registra o service worker e avisa de versão nova (Onda 6.2). */}
    <UpdatePrompt />
  </StrictMode>,
)
